import msg from 'services/msg'

const intervals = [
  { ms: 31536000, i: 'year' },
  { ms: 2592000, i: 'month' },
  { ms: 604800, i: 'week' },
  { ms: 86400, i: 'day' },
  { ms: 3600, i: 'hour' },
  { ms: 60, i: 'minute' }
]

export function getElapsedTime(dateMillis: number): string {
  if (!dateMillis) {
    return ''
  }
  const nowMillis = new Date().getTime()
  const diff = Math.floor((nowMillis - dateMillis) / 1000)
  let interval
  let num = 0
  for (let i = 0; i < intervals.length; i++) {
    if (diff >= intervals[i].ms) {
      interval = intervals[i].i
      num = Math.floor(diff / intervals[i].ms)
      break
    }
  }
  if (!interval) {
    return msg('time.lessThanMinuteAgo')
  }
  return msg(`time.${interval}sAgo`, [num], num)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/time-utils.ts